'use client';
import {countBiteStage,checkoutFlowDetails} from './bite-conversion';
import {trackBiteGa4,biteGa4CheckoutContext} from './bite-ga4';
import {biteGa4PolicyContext} from './bite-ga4-policy';
const KEY='bite.login.pending.v1';
let observing:Promise<void>|null=null;
export function beginBiteLoginMeasurement(next:string) {
  try{sessionStorage.setItem(KEY,JSON.stringify({at:Date.now(),details:checkoutFlowDetails(next),counted:false,google:false}));}catch{}
}
export function completeBiteLoginMeasurement() {
  if(observing)return observing;
  const run=async()=>{
    let pending;
    try{pending=JSON.parse(sessionStorage.getItem(KEY)||'null');}catch{return;}
    if(!pending)return;
    if(!Number.isFinite(pending.at)||Date.now()-pending.at>86400000){sessionStorage.removeItem(KEY);return;}
    if(!pending.counted){
      // The count endpoint verifies the authenticated server session; its queue retries the same event ID.
      const ga4=await biteGa4CheckoutContext();
      void countBiteStage('login_success',{...pending.details,...(ga4?{measurement:{measurementMode:'ga4-only',ga4,...biteGa4PolicyContext()}}:{})});
      pending.counted=true;
      try{sessionStorage.setItem(KEY,JSON.stringify(pending));}catch{}
    }
    if(!pending.google)pending.google=await trackBiteGa4('login_success',pending.details);
    try{if(pending.google)sessionStorage.removeItem(KEY);else sessionStorage.setItem(KEY,JSON.stringify(pending));}catch{}
  };
  observing=run().catch(()=>{}).finally(()=>{observing=null;});
  return observing;
}
